import { render, staticRenderFns } from "./VendaBlocoDeLista.vue?vue&type=template&id=0a536116&scoped=true&lang=pug"
import script from "./VendaBlocoDeLista.vue?vue&type=script&lang=js"
export * from "./VendaBlocoDeLista.vue?vue&type=script&lang=js"
import style0 from "./VendaBlocoDeLista.vue?vue&type=style&index=0&id=0a536116&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a536116",
  null
  
)

export default component.exports